var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAapmorlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 42,
    viewBox: "0 0 46 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8733 35.0768C39.8733 36.039 39.0932 36.8191 38.131 36.8191C37.1687 36.8191 36.3887 36.039 36.3887 35.0768C36.3887 34.1145 37.1687 33.3345 38.131 33.3345C39.0932 33.3345 39.8733 34.1145 39.8733 35.0768Z",
    fill: "#01409D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9508 35.0768C43.9508 36.039 43.1708 36.8191 42.2085 36.8191C41.2463 36.8191 40.4662 36.039 40.4662 35.0768C40.4662 34.1145 41.2463 33.3345 42.2085 33.3345C43.1708 33.3345 43.9508 34.1145 43.9508 35.0768Z",
    fill: "#01409D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8988 29.484C37.5655 29.4612 37.23 28.6797 38.0227 28.302C38.5487 28.3022 39.608 28.2155 39.617 28.7173C39.6283 29.3483 38.9021 29.7296 38.4284 29.9046C37.9548 30.0795 38.1366 29.6881 37.8988 29.484Z",
    fill: "#01409D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67662 34.1284C3.28825 34.0775 1.7082 34.9949 1.09657 34.9949C0.758775 34.9949 0.332031 34.7667 0.332031 34.4852C0.332031 34.2037 0.758775 33.9755 1.09657 33.9755C1.43436 33.9755 2.67662 33.8469 2.67662 34.1284Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5979 35.0768C39.5979 36.039 38.8178 36.8191 37.8556 36.8191C36.8933 36.8191 36.1133 36.039 36.1133 35.0768C36.1133 34.1145 36.8933 33.3345 37.8556 33.3345C38.8178 33.3345 39.5979 34.1145 39.5979 35.0768Z",
    fill: "url(#paint0_linear_2531_635)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6754 35.0768C43.6754 36.039 42.8954 36.8191 41.9331 36.8191C40.9709 36.8191 40.1908 36.039 40.1908 35.0768C40.1908 34.1145 40.9709 33.3345 41.9331 33.3345C42.8954 33.3345 43.6754 34.1145 43.6754 35.0768Z",
    fill: "url(#paint1_linear_2531_635)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1925 33.3011C28.5012 33.4072 27.7265 34.15 27.2151 34.15C26.7037 34.15 26.2377 33.8848 26.3405 33.3011C26.4167 32.8687 27.2181 32.9297 27.7295 32.9297C28.2409 32.9297 28.0382 33.0889 28.1925 33.3011Z",
    fill: "#0542A9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2125 35.9515C30.6024 36.0576 29.6238 36.8004 28.9778 36.8004C28.3318 36.8004 27.792 36.5352 27.9218 35.9515C28.0179 35.5191 28.9817 35.5801 29.6277 35.5801C30.2737 35.5801 30.0176 35.7393 30.2125 35.9515Z",
    fill: "#0643AE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67662 34.1283C3.28825 34.0774 1.7082 34.9949 1.09657 34.9948C0.758775 34.9948 0.332031 34.7666 0.332031 34.4851C0.332031 34.2036 0.758775 33.9754 1.09657 33.9754C1.43436 33.9754 2.67662 33.8468 2.67662 34.1283Z",
    fill: "#0E48D0"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3415 2.2943C25.9166 0.467007 25.3217 0.849464 21.7946 0.849464C21.2506 0.853058 20.633 1.81419 20.3922 2.2943L1.12748 34.9092C1.12537 34.9127 1.12396 34.9167 1.12332 34.9208C1.11988 34.9428 1.13902 34.9618 1.16103 34.9581L1.40119 34.9181C1.41513 34.9157 1.42902 34.9119 1.4422 34.9068C3.84726 33.978 5.20958 33.2857 7.58942 32.212C7.65162 32.184 7.70341 32.1356 7.7352 32.0752L10.1499 27.4874C10.2028 27.3869 10.307 27.324 10.4205 27.324H19.0252C19.1348 27.324 19.236 27.2653 19.2905 27.1703L20.7671 24.5948C20.884 24.3909 20.7368 24.1368 20.5018 24.1368H12.2238C11.9855 24.1368 11.8387 23.8762 11.9623 23.6724L22.3854 6.48638C22.5327 6.24354 22.9026 6.31512 22.9486 6.59536L25.7995 23.9418C25.8191 24.0605 25.7671 24.1796 25.6669 24.2462L21.8743 26.7634C21.6219 26.9309 21.7405 27.324 22.0434 27.324H26.0447C26.1921 27.324 26.3185 27.4292 26.3454 27.5741L27.4681 33.6366C27.5129 33.8787 27.8109 33.9712 27.985 33.7971L31.2395 30.5426C31.3122 30.4699 31.3435 30.3655 31.3228 30.2648L30.794 27.6914C30.7551 27.5017 30.9 27.324 31.0936 27.324L42.8574 27.3518L45.4426 24.4872C45.6212 24.2892 45.2667 23.9675 45 23.9707L30.3436 24.1337C30.1926 24.1355 30.0637 24.0316 30.039 23.8826C28.919 17.1233 26.6772 3.73781 26.3415 2.2943Z",
    fill: "url(#paint2_linear_2531_635)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1471 28.8113H36.4131C36.3314 28.8113 36.2531 28.844 36.1957 28.902L28.8967 36.2795C28.7056 36.4726 28.8424 36.8004 29.1141 36.8004H32.2013C32.2856 36.8004 32.3661 36.7656 32.4239 36.7042L39.3697 29.3268C39.5535 29.1316 39.4151 28.8113 39.1471 28.8113Z",
    fill: "url(#paint3_linear_2531_635)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2202 2.2943C24.7953 0.467007 24.2003 0.849464 20.6732 0.849464C20.1293 0.853058 19.5117 1.81419 19.2709 2.2943L0.375971 34.2831C0.224897 34.5388 0.490381 34.8381 0.762327 34.7186L6.46701 32.2114C6.53035 32.1836 6.58237 32.1351 6.61459 32.0739L9.02855 27.4874C9.08143 27.3869 9.18563 27.324 9.29917 27.324H17.9039C18.0134 27.324 18.1146 27.2653 18.1692 27.1703L19.6458 24.5948C19.7627 24.3909 19.6155 24.1368 19.3805 24.1368H11.1025C10.8642 24.1368 10.7174 23.8762 10.841 23.6724L21.2641 6.48638C21.4113 6.24354 21.7813 6.31512 21.8273 6.59536L24.6782 23.9418C24.6977 24.0605 24.6458 24.1796 24.5456 24.2462L20.753 26.7634C20.5006 26.9309 20.6192 27.324 20.9221 27.324H24.9233C25.0708 27.324 25.1972 27.4292 25.2241 27.5741L26.3467 33.6366C26.3916 33.8787 26.6896 33.9712 26.8637 33.7971L30.1182 30.5426C30.1909 30.4699 30.2222 30.3655 30.2015 30.2648L29.6727 27.6914C29.6337 27.5017 29.7786 27.324 29.9723 27.324L42.8574 27.3518C42.8574 27.3518 41.2977 27.3882 41.3557 27.324L43.9408 24.4594C44.1195 24.2614 44.2075 23.9675 43.9408 23.9707L29.2223 24.1337C29.0713 24.1355 28.9424 24.0316 28.9177 23.8826C27.7977 17.1233 25.5559 3.73781 25.2202 2.2943Z",
    fill: "url(#paint4_linear_2531_635)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2686 28.2904H35.5346C35.453 28.2904 35.3747 28.3231 35.3172 28.3811L28.0182 35.7586C27.8272 35.9517 27.964 36.2795 28.2356 36.2795H31.3228C31.4071 36.2795 31.4877 36.2447 31.5455 36.1833L38.4913 28.8059C38.675 28.6107 38.5367 28.2904 38.2686 28.2904Z",
    fill: "url(#paint5_linear_2531_635)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2531_635",
    x1: 45.9292,
    y1: 35.2474,
    x2: 39.4372,
    y2: 41.0535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E48D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519419,
    stopColor: "#FE899B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F07"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2531_635",
    x1: 45.9292,
    y1: 35.2474,
    x2: 39.4372,
    y2: 41.0535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E48D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519419,
    stopColor: "#FE899B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F07"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2531_635",
    x1: 5.84847,
    y1: 27.0357,
    x2: 26.3178,
    y2: 14.6781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.186667,
    stopColor: "#0E48D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617077,
    stopColor: "#02409D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2531_635",
    x1: 5.84847,
    y1: 27.0357,
    x2: 26.3178,
    y2: 14.6781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.186667,
    stopColor: "#0E48D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617077,
    stopColor: "#02409D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2531_635",
    x1: 35.7887,
    y1: 5.74488,
    x2: 4.24047,
    y2: 35.9452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E48D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#FE899B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F07"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2531_635",
    x1: 35.7887,
    y1: 5.74488,
    x2: 4.24047,
    y2: 35.9452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E48D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#FE899B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F07"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAapmorlogo);
export default __webpack_public_path__ + "static/media/AAPMOR LOGO.e7870546dc7e0f46554e09364895f3af.svg";
export { ForwardRef as ReactComponent };